import Vue from 'vue'
import Router from 'vue-router'

const WebHome = r => require.ensure([], () => r(require('@/pages/WebHome')), 'WebHome')
const Home = r => require.ensure([], () => r(require('@/pages/home/Home')), 'Home')
const Anno = r => require.ensure([], () => r(require('@/pages/home/Anno')), 'Anno')
const Summary = r => require.ensure([], () => r(require('@/pages/home/Summary')), 'Summary')
const Ecosystem = r => require.ensure([], () => r(require('@/pages/home/Ecosystem')), 'Ecosystem')
const Mining = r => require.ensure([], () => r(require('@/pages/home/Mining')), 'Mining')
const Download = r => require.ensure([], () => r(require('@/pages/home/Download')), 'Download')
const Video = r => require.ensure([], () => r(require('@/pages/home/Video')), 'Video')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'WebHome',
      redirect: '/home/home',
      component: WebHome,
      children: [
        { path: '/home/home', name: 'home', component: Home },
        { path: '/home/anno', name: 'anno', component: Anno },
        { path: '/home/summary', name: 'summary', component: Summary },
        { path: '/home/ecosystem', name: 'ecosystem', component: Ecosystem },
        { path: '/home/mining', name: 'mining', component: Mining },
        { path: '/home/download', name: 'download', component: Download },
        { path: '/home/video', name: 'video', component: Video }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js